import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'shared-components/components/Grid';

import './style.scss';

const propTypes = {
  title: PropTypes.string,
};

const defaultProps = {
  title: 0,
};

const RecentAdsLimiter = ({
  title,
}) => (
  <Grid className="recent-ads-limiter" direction="column">
    <p className="recent-ads-limiter__ads_text tp-w--l tp-s--xl">{title}</p>
  </Grid>
);

RecentAdsLimiter.propTypes = propTypes;
RecentAdsLimiter.defaultProps = defaultProps;

export default RecentAdsLimiter;
